import { TableV2 } from '@medeloop/medeloop-components-library';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetOrganization } from 'src/api/organizations-queries';

export function DataSetsTable() {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { organizationId } = useParams();

  const { data, isLoading } = useGetOrganization(organizationId);

  const dataSources = useMemo(() => data?.dataSources ?? [], [data]);

  const headers = [
    { label: 'Name', key: 'dataSourceName' },
    { label: 'Display name', key: 'dataSourceDisplayName' },
    { label: 'Created', key: 'createdDate' },
  ];

  const transformedData = useMemo(
    () =>
      dataSources
        .filter(
          (dataSource) =>
            dataSource.dataSourceName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            dataSource.dataSourceDisplayName.toLowerCase().includes(searchTerm.toLowerCase()),
        )
        .map((dataSource) => ({
          id: dataSource.dataSourceId,
          dataSourceName: dataSource.dataSourceName,
          dataSourceDisplayName: dataSource.dataSourceDisplayName,
          createdDate: new Date(dataSource.createdAt).toISOString().split('T')[0],
        })) ?? [],
    [dataSources, searchTerm],
  );

  return (
    <section className="flex flex-col w-full mt-12 border border-stroke-on-dark-subdued rounded-lg bg-background-dark-subdued px-4 py-6">
      <TableV2
        headers={headers}
        data={transformedData}
        searchPlaceholder="Search by name"
        onSearch={(t) => setSearchTerm(t)}
        isLoading={isLoading}
      />
    </section>
  );
}
